import React from 'react';
import Header from "components/Headers/Header.js";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from "react";
import { Card, CardHeader, CardBody, Container, Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {Link} from 'react-router-dom'

function ApiKeys() {
  const token = useSelector((state) => state.userLogin.userInfo.token);
  const [show, setShow] = useState(false);  // Show/hide API key
  const [copied, setCopied] = useState(false);  // Show/hide copied message
  const [countdown, setCountdown] = useState(10);  // Countdown for hiding API key

  const { t, i18n } = useTranslation();  

  useEffect(() => {
    const storedLanguage = localStorage.getItem('selectedLanguageAFS');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);

  // Function to handle showing API key and starting countdown
  const ShowsApiKeys = () => {
    setShow(true);        // Show API key immediately
    setCountdown(10);      // Reset the countdown to 10 seconds
    toggleModal()

    const intervalId = setInterval(() => {
      setCountdown(prev => {
        if (prev === 1) {
            clearInterval(intervalId);  // Stop countdown at 0
            setShow(false);             // Hide the API key after countdown ends
          }
          return prev - 1;
        });
    }, 1000);               // Update countdown every second

    toggleModal()
  };

  const submitcopied = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);  // Hide "Copied" message after 2 seconds
  };

  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);

  return (
    <div>
      <Header />
      <Container className="mt--15" fluid>
        <Row>
          <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
            <Card>
              <CardHeader>
                <h3>{t('API Keys')}</h3>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
                    <Button color="success" onClick={ShowsApiKeys} disabled={show}>
                      {t('Show API Keys')}
                    </Button>
                  </Col>
                  <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
                    <Link to="/">
                      <Button color="primary">
                        {t('Go back')} <i className="fas fa-rotate-left"></i>
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
            <Card>
              <CardHeader>
                <h3>{t('API Documentation')}</h3>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="text-center mt-5">
                    <Link to="https://fruitkountbackend.automaticfarmsolutionwebapp.com/" target="_blank" rel="noopener noreferrer">
                      <Button color='warning'>
                        {t('Go to Swagger Documentation')} 
                      </Button>
                    </Link>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="text-center mt-5">
                    <Link to="https://automaticfarmsolution.live/fruitkount_getting_started" target="_blank" rel="noopener noreferrer">
                      <Button color='info'>
                        {t('Go to API Documentation')} 
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal isOpen={modalOpen} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>{t('API Key')}</ModalHeader>
          <ModalBody className="text-center">
            <p>{t('Our API Keys follow the rule of JSON Web Token')}</p>
            <p>{t('Please use the following API Keys as Bearer Authentication Token')}</p>
            <h3>{t('You have')} {countdown} {t('seconds to copy the API key')}</h3>
            {show && (
              <p style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>{token}</p>
            )}
            <CopyToClipboard text={token} onCopy={submitcopied}>
              <Button size='sm' color='primary'>
                {t('Copy the API Key')}
              </Button>
            </CopyToClipboard>
            {copied && <p>{t('Copied')}</p>}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={toggleModal}>{t('Close')}</Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
}

export default ApiKeys;
